export const safeNull = (v, def = undefined) => {
    if (v === null) {
        return def
    }

    return v
}

export const randomColor = () => [Math.floor(Math.random() * 255), Math.floor(Math.random() * 255), Math.floor(Math.random() * 255)]

export function areObjectsDifferent(obj1, obj2) {
    if (obj1 === obj2) return false

    if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null) {
        return true // Primitive or null mismatch
    }

    const keys1 = Object.keys(obj1)
    const keys2 = Object.keys(obj2)

    if (keys1.length !== keys2.length) return true

    return keys1.some(key => !keys2.includes(key) || areObjectsDifferent(obj1[key], obj2[key]))
}

export const updateQueryParams = (key, value) => {
    const params = new URLSearchParams(window.location.search)
    params.set(key, value)
    window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`)
}

export const isValueSet = (val) => {
    if (val === undefined || val === null) return false
    if (val === "") return false
    if (Array.isArray(val) && val.length === 0) return false

    return true
}

function rgbToArray(rgbString) {
    const match = rgbString.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
    if (!match) {
        return [255, 255, 255]
    }

    return match.slice(1, 4).map(Number)
}

export const darkenRGBString = (stroke, factor) => rgbToArray(stroke).map(x => Math.max(0, x - factor))
export const brightenRGBString = (stroke, factor) => rgbToArray(stroke).map(x => Math.min(255, x + factor))

export const trimStringToLength = (str, length) => {
    if (str.length > length) {
        return `${str.substring(0, length)}...`
    }

    return str
}

export const trimLeadingSpaces = (str) => str.replace(/^\s+/, '')


export const flatten = (list) => {
    const result = []
    for (const item of list) {
        if (Array.isArray(item)) {
            result.push(...item)
        } else {
            result.push(item)
        }
    }
    return result
}

export const stringHasContent = (val) => (val || "").toString()?.length > 0

export const formatBytes = bytes => {
    if (bytes === undefined) return "0 B"

    if (bytes < 1024) return bytes + " B";
    let units = ["KB", "MB", "GB", "TB"];
    let i = -1;
    do {
        bytes /= 1024;
        i++;
    } while (bytes >= 1024 && i < units.length - 1);
    
    return bytes.toFixed(2) + " " + units[i];
}

export const camelToNormal = (text) => text.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase())